var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.accrochage)?_c('div',[_c('h2',{staticClass:"sectionTitle"},[_vm._v(_vm._s(_vm.section_title))]),_c('AccrochagePreview',{ref:"preview",attrs:{"accrochage":_vm.accrochage}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }